var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1555_13231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21C3 23.4854 5.01473 25.5 7.5 25.5H28.5C30.9854 25.5 33 23.4854 33 21V9C33 6.51473 30.9854 4.5 28.5 4.5H7.5C5.01473 4.5 3 6.51473 3 9V21Z",
    fill: "#3AB100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5H12C11.1716 31.5 10.5 30.8284 10.5 30C10.5 29.1715 11.1716 28.5 12 28.5H24C24.8284 28.5 25.5 29.1715 25.5 30C25.5 30.8284 24.8284 31.5 24 31.5Z",
    fill: "#3AB100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1555_13231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.0d3ac5856594931e2be1227a65829777.svg";
export { ForwardRef as ReactComponent };